import axios from 'axios';
import RouteUrls from '../common/RouteUrls';
import {getXSRFToken} from '../common/authTokenUtil';

export const validateDuplicateUserId = async (userId) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.VALIDATE_DUPLICATE_USER_ENDPOINT,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET'
      },
      data: {
        loginName: userId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user ID : ', error);
    throw error;
  }
};

export const getAccessCode = async (orgId, userId, email) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.GET_ACCESS_CODE,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET'
      },
      data: {
        organizationNumber: orgId,
        loginName: userId,
        email: email
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Access Code : ', error);
    throw error;
  }
};

export const verifyAccessCode = async (userId, accessCode, accessResourceToken) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.VERIFY_ACCESS_CODE,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'X-XSRF-TOKEN': getXSRFToken()
      },
      data: {
        userId: userId,
        accessCode: accessCode,
        accessResourceToken: accessResourceToken + "-VAC",
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying Access Code : ', error);
    throw error;
  }
}

export const changePassword = async (userId, newSecretPhrase, accessResourceToken) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.CHANGE_PASSWORD,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'device-id': '12345',
        'X-XSRF-TOKEN': getXSRFToken()
      },
      data: {
        userId: userId,
        newSecretPhrase: newSecretPhrase,
        confirmNewSecretPhrase: newSecretPhrase,
        accessResourceToken: accessResourceToken + "-CPW"

      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
